import { apiBase } from './apiBase';
import { ClientConfig, ClientConfigRequest } from '@/types/types';

export const clientApi = apiBase.injectEndpoints({
  endpoints: (builder) => ({
    getClient: builder.query<
      ClientConfig | ClientConfig[],
      ClientConfigRequest
    >({
      query: ({ siteId }) => {
        return `external/config?siteId=${siteId}`;
      },
      keepUnusedDataFor: 0.0001,
    }),
  }),
});

export const { useGetClientQuery } = clientApi;
